import { autoinject } from 'aurelia-framework';
import { CreateBaseView } from 'General/Views/Dynamic/Create/CreateBaseView';

@autoinject
export class CreateView extends CreateBaseView { 

}